import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { ButtonMui } from "@/components/ui";
import { FullWidthLayout } from "@/layouts";
import { SectionTitle } from "../../home/home.styles";
import * as Styled from "./mainFreeTrial.styles";

export const MainFreeTrial = () => {
  const { t } = useTranslation("global");

  const itemsArray = [1, 2, 3, 4, 5, 6];

  return (
    <FullWidthLayout id="free-trial" bgColor="var(--background-light)">
      <Styled.SectionContainer>
        <Styled.MainInnerContainer>
          <Styled.ImgContainer>
            <Styled.ImgBoxSmall>
              <img src="/assets/freeTrial/home/mockupSmall.png" alt="mockup-cellect" className="animate__animated animate__fadeIn" />
            </Styled.ImgBoxSmall>
            <Styled.ImgBoxBig>
              <img src="/assets/freeTrial/home/mockupBig.png" alt="mockup-cellect" className="animate__animated animate__fadeIn" />
            </Styled.ImgBoxBig>
          </Styled.ImgContainer>
          <Styled.ContentBox>
            <SectionTitle className="display-large" color="var(--on-background-light)">
              {t("freeTrialScreen.title")}
            </SectionTitle>
            <Styled.ButtonBox>
              <ButtonMui
                color="primary"
                size="medium"
                variant="contained"
                className="animate__animated animate__fadeIn"
                endIcon={<ArrowForwardIcon width={1} />}
              >
                <a href="#signUp">{t("freeTrialScreen.button")}</a>
              </ButtonMui>
              <ButtonMui size="medium" variant="text" color="primary">
                <Link href="/contact">{t("freeTrialScreen.link")}</Link>
              </ButtonMui>
            </Styled.ButtonBox>
          </Styled.ContentBox>
        </Styled.MainInnerContainer>
        <Styled.FootContainer>
          <Styled.DescriptionContainer>
            <Styled.Descripton className="headline-large" color="var(--on-background-light)">
              {t("freeTrialScreen.description")}
            </Styled.Descripton>
          </Styled.DescriptionContainer>
          <div>
            <Styled.UlContainer>
              {itemsArray.map((item, i) => (
                <Styled.Item key={i}>
                  <span>
                    <Image src={`/assets/freeTrial/itemsHome/icon${item}.svg`} alt="icon-cellect" width={25} height={25} />
                  </span>
                  <p className="body-medium" style={{ color: "var(--on-background-light)" }}>
                    {t(`freeTrialScreen.items.title${item}`)}
                  </p>
                </Styled.Item>
              ))}
            </Styled.UlContainer>
          </div>
        </Styled.FootContainer>
      </Styled.SectionContainer>
    </FullWidthLayout>
  );
};
